import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
// import { img2 } from "../_components/imagepath";
// import FeatherIcon from "feather-icons-react";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider } from "formik";
// import * as Yup from "yup";
import {  Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const EmployeeSettingAdd = () => {


  const [menu, setMenu] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
  const [primaryCurrency, setPrimaryCurrency] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState('dh');
  const [permission, setPermission] = useState({});

  const [paymentMethods, setPaymentMethods] = useState([]);  
 


  const toggleMobileMenu = () => {
    setMenu(!menu);
  };



  const formik = useFormik({
    initialValues: {
      gross_hourly_wage: "",
      cnss_rate: "",
      amo_rate:''
    },
    onSubmit: (values,{ setSubmitting }) => {
      //alert(JSON.stringify(values, null, 2));
      axios
        .post("/employee-setting/add", values, {
          headers: {
             Authorization: `Bearer ${Authtoken}`,
             Apitoken: Apitoken,
             "Content-Type": "multipart/form-data",
            },
        })
        .then((response) => {
          
          delete backendErrors['error'];
          setSubmitting(false);
         // actions.setSubmitting(false);
         $("#form-submit").text("Add Setting");
          if (response.data.code === 200) {
           // setBackendSuccess(response.data.message);
            toast.success(response.data.message);
         //   actions.resetForm();
            setTimeout(() => {
              window.location.href = "/employee-setting";
            }, 1000);
          }  else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    },
  });

 
  useEffect(() => {
        setPermission(FindModuleById(442)); 
console.log(permission);


    axios
    .get(`/helpers/currencies`, {
      headers: {
        Authorization: `Bearer ${Authtoken}`,
        Apitoken: Apitoken,
      },
    })
    .then((response) => {
      if (response.data.code === 200) {
        let emp_status = response.data.data.currencies;
         let emp_statusList = emp_status.map((ord, index) => ({
           label:  ord.title ,
           value: ord.id,
           key: `sts-${index}`,
         }));
         setPrimaryCurrency(emp_statusList);

      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });
      axios
      .get(`/helpers/expenses-payment-methods`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let types = response.data.data.methods;
          let typeslisting = types.map((ord, index) => ({
            label: ord.title,
            value: ord.id,
            key: `location-${index}`,
          }));
          setPaymentMethods(typeslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

      
  

}, []);

  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };

  const customFuction = (event) =>{
    var index = event.target.selectedIndex;
    var optionElement = event.target.childNodes[index];
    var key_sybmol =  optionElement.getAttribute('key_sybmol');
    console.log(key_sybmol);
    setCurrencySymbol(key_sybmol)
   
  }
  const operationArr =[
    { value: 'IN', label: "IN" },
    { value: 'OUT', label: "OUT" },
  ];
  
const handleSelectChange = (name, selectedOption) => {
  const value = selectedOption ? selectedOption.value : "";
  updateFormikValue(name, value);
  customHandleInput({ target: { name, value } });
};

const updateFormikValue = (name, value) => {
  formik.setFieldValue(name, value);
};

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Caisse</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/employee-setting">Caisse</Link>
                    </li>
                    <li className="breadcrumb-item active">Add Caisse</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Caisse Information</h4>
                     {permission && permission.add == 1 && ( 
 <FormikProvider value={formik}>
                      <form onSubmit={formik.handleSubmit}>
                     
                        <div className="row">
                        <div className="col-md-6">
                       <div className="form-group status">
                           <label>Select Operation</label>
                           <Select
                            className="w-100"
                            value={operationArr.find(option => option.value == formik.values.operation) || null} // Ensure correct format
                            name="operation"
                            onChange={(selectedOption) => {
                              handleSelectChange("operation", selectedOption);
                            //  customHandleStatus(selectedOption);
                            }}
                            onBlur={formik.handleBlur}
                            options={operationArr}
                            placeholder="Select"

                           />
                           <small>
                             {backendErrors.operation  && (
                               <span className="form-error mt-1">
                                 {backendErrors.operation}
                               </span>
                             )}
                           </small>
                         </div>
                       </div>
                        <div className="col-md-6">
                            <div className="form-group status2">
                              <label>Select Currency</label>
                              <Select
                                  className="w-100"
                                  value={primaryCurrency.find(option => option.value == formik.values.currency) || null} // Ensure correct format
                                  name="currency"
                                  onChange={(selectedOption) => {
                                    handleSelectChange("currency", selectedOption);
                                   customFuction(selectedOption);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={primaryCurrency}
                                  placeholder="Select"

                           />
                            
                              <small>
                                {backendErrors.currency && (
                                    <span className="form-error mt-1">
                                      {backendErrors.currency}
                                    </span>
                                  )}
                              </small>
                              </div>
                             
                            </div>
                        <div className="col-md-6">
                          <div className="form-group">
                              <label>Amount</label>
                             
                              <div className="input-group">
                                  <input 
                                   type="text"
                                  onKeyPress={(event) => {
                                    // Allow only numbers (0-9)
                                    if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                      event.preventDefault();
                                    }
                                  }}
                                  name="amount"
                                  value={formik.values.amount}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                    onBlur={formik.handleBlur}
                                  className="form-control" placeholder="Amount" aria-label="Amount" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                      <span className="input-group-text" id="basic-addon2">{currencySymbol}</span>
                                  </div>
                              </div>
                              <small>
                                {backendErrors.amount && (
                                    <span className="form-error mt-1">
                                      {backendErrors.amount}
                                    </span>
                                  )}
                              </small>
                            </div>
                       </div>
                       <div className="col-md-6">
                          <div className="form-group">
                              <label>Date</label>
                              <input
                                type="date"
                                name="date"
                                value={formik.values.date}
                                className={
                                  backendErrors.date
                                    ? "form-input form-control input-error datetimepicker"
                                    : "form-input form-control datetimepicker"
                                }
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                 onBlur={formik.handleBlur}
                              />
                              <small>
                                {backendErrors.date && (
                                    <span className="form-error mt-1">
                                      {backendErrors.date}
                                    </span>
                                  )}
                              </small>
                            </div>
                       </div>
                     

                          <div className="col-md-6">
                            <div className="form-group status2">
                                <label>Select Payment Method</label>
                                <Select
                                  className="w-100"
                                  value={paymentMethods.find(option => option.value == formik.values.payment_method) || null} // Ensure correct format
                                  name="payment_method"
                                  onChange={(selectedOption) => {
                                    handleSelectChange("payment_method", selectedOption);
                                   customFuction(selectedOption);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={paymentMethods}
                                  placeholder="Select"

                           />
                            
                                <small>
                                  {backendErrors.payment_method && (
                                      <span className="form-error mt-1">
                                        {backendErrors.payment_method}
                                      </span>
                                    )}
                                </small>
                              </div>
                          </div>

                          <div className="col-md-12">
                              <label>Note</label>
                                  <textarea 
                                  name="note"
                                  value={formik.values.note}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                    onBlur={formik.handleBlur}
                                  className="form-control" placeholder="Note" >
                                  </textarea>
                              <small>
                                {backendErrors.note && (
                                    <span className="form-error mt-1">
                                      {backendErrors.note}
                                    </span>
                                  )}
                              </small>
                         </div>

                       

                        </div>

                      
                        <div className="text-end mt-4">
                          <button className="btn btn-primary" type="submit" id="form-submit"  disabled={formik.isSubmitting}>
                          Add Setting
                          </button>
                        </div>
                      </form>
                    </FormikProvider>
                     )}
                   
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default EmployeeSettingAdd;
